import type { ShigoUser } from '../../features/auth/model';
import { dashboardT } from '../../lib/messages';

interface NamedDashboard {
  name: string;
}

/** Name shown in the account menu: the active agency/publisher dashboard, then the user. */
export function accountDisplayName({
  user,
  activeAgency,
  activePublisher,
}: {
  user: ShigoUser | undefined;
  activeAgency: NamedDashboard | undefined;
  activePublisher: NamedDashboard | undefined;
}): string {
  return (
    activeAgency?.name ??
    activePublisher?.name ??
    user?.name ??
    user?.email ??
    dashboardT('account.admin')
  );
}

/** Up to two uppercase initials of the account name, `SA` when it has none. */
export function accountInitials(accountName: string) {
  const initials = accountName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
  return initials || 'SA';
}
